import { VisitorType } from "../constants/common";
import i18n from "../i18n";
import * as Yup from "yup";

export const createGroupSchema = (visitPurposes: any, roleId?: number) => {
  return Yup.object({
    location: Yup.string().required(
      i18n.language === "en" ? "Location is required." : "الموقع مطلوب."
    ),
    building: Yup.string().required(
      i18n.language === "en" ? "Building is required." : "مطلوب بناء"
    ),
    visitingDepartment: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "Department is required." : "القسم مطلوب."
        ),
    }),

    gate: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "Gate is required." : "البوابة مطلوبة."
        ),
    }),

    meetingRoom: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.notRequired(),
    }),

    visitReqType: Yup.string().required(
      i18n.language === "en"
        ? "Visit Request Type is required."
        : "نوع طلب الزيارة مطلوب."
    ),
    visitPurpose: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en" ? "Purpose is required." : "الهدف مطلوب."
        ),
    }),
    visitPurposeOther: Yup.string().when("visitReqType", {
      is: VisitorType.VVIP,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.when(["visitPurpose"], {
          is: (visitPurpose: string) => {
            const purpose =
              visitPurposes?.find(
                (item: any) => item.value === Number(visitPurpose)
              )?.labelEn || "";

            return purpose.trim() === "Other";
          },
          then: (schema) =>
            schema
              .matches(
                /^.{1,50}$/,
                i18n.language === "en"
                  ? "Visit purpose (Other) must not exceed 50 characters."
                  : "الغرض الآخر لا يجب أن يتجاوز 50 حرفًا."
              )
              .required(
                i18n.language === "en"
                  ? "Visit purpose (Other) is required."
                  : "الغرض الآخر مطلوب."
              ),
          otherwise: (schema) => schema.notRequired(),
        }),
    }),
    hostEmail: Yup.string()
      .email(
        i18n.language === "en" ? "Invalid email" : "البريد الإلكتروني غير صالح."
      )
      .required(
        i18n.language === "en"
          ? "Host email is required."
          : "البريد الإلكتروني للمضيف مطلوب."
      ),
    hostMobileNumber: Yup.string()
      .required(
        i18n.language === "en"
          ? "Host mobile number is required."
          : "رقم الهاتف المحمول المضيف مطلوب."
      )
      .matches(
        /^\d{1,14}$/,
        i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
      ),
    visitStartDate: Yup.string().required(
      i18n.language === "en"
        ? "Visit Start Date is required."
        : "تاريخ بداية الزيارة مطلوب."
    ),
    visitEndDate: Yup.string().required(
      i18n.language === "en"
        ? "Visit End Date is required."
        : "تاريخ نهاية الزيارة مطلوب."
    ),

    plateSource: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Source is required."
            : "مصدر اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    plateNumber: Yup.string()
      .nullable()
      .when("$isVehicleInfoVisible", {
        is: true,
        then: (schema) =>
          schema
            .matches(
              /^[0-9\u0660-\u0669]{1,6}$/,
              i18n.language === "en"
                ? "Enter a valid plate number."
                : "أدخل رقم لوحة صالح."
            )
            .required(
              i18n.language === "en"
                ? "Plate Number is required."
                : "رقم اللوحة مطلوب."
            ),
        otherwise: (schema) => schema.nullable(),
      }),
    plateLetter1: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Letter 1 is required."
            : "الحرف الأول من اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    plateLetter2: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Letter 2 is required."
            : "الحرف الثاني من اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    plateLetter3: Yup.string().when("$isVehicleInfoVisible", {
      is: true,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Plate Letter 3 is required."
            : "الحرف الثالث من اللوحة مطلوب."
        ),
      otherwise: (schema) => schema.nullable(),
    }),

    note: Yup.string(),
    // reqAccessLevels: Yup.string().when([], {
    //   is: () => isSecurity,
    //   then: (schema) => schema.notRequired(),
    //   otherwise: (schema) =>
    //     schema.when("visitReqType", {
    //       is: VisitorType.VVIP,
    //       then: (schema) => schema.notRequired(),
    //       otherwise: (schema) =>
    //         schema.required(
    //           i18n.language === "en"
    //             ? "Request access levels is required."
    //             : "مستويات الوصول المطلوبة مطلوبة."
    //         ),
    //     }),
    // }),
    // accessLevels: Yup.string().when([], {
    //   is: () => isSecurity,
    //   then: (schema) =>
    //     schema.required(
    //       i18n.language === "en"
    //         ? "Access levels is required."
    //         : "مستويات الوصول مطلوبة"
    //     ),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
  });
};
